import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaXTwitter, FaYoutube, FaInstagram, FaLinkedin } from "react-icons/fa6";
import bg from '../images/best.jpg'

const functionalities = [
  { 
    icon: 'NEW👀',
    title: 'GENERATE SNAPSHOTS !',
    desc: 'GET DETAILED SNAPSHOTS OF TOPIC YOU ENTER'
   },
  { 
    icon: 'NEW👀',
    title: 'QUESTION PAPER GENERATOR FOR TEACHERS!',
    desc: 'JUST SELECT THE TOPIC, AND GET A WHOLE .DOCX OR .PDF FILE OF READY TO USE QUESTION PAPER'
   },
  { 
    icon: '📊',
    title: 'Mind Maps & Diagrams',
    desc: 'Get mind maps from your content and get concepts visually.'
   },
   {
     icon: '🤔',
     title: 'Possible Doubt generation',
     desc: 'Even get the possible doubts that can come to your mind while studying the content..'
   },
   { 
     icon: '🤩',
     title: 'GET STUDY PLAN FOR YOUR MATERIAL',
     desc: 'YOU CAN GET DETAILED STUDY PLAN BASED ON YOUR CONTENT!'
     },
     {
       icon: '📌',
       title: 'Knowledge Graphs',
       desc: 'Get knowledge graphs for better understanding.'
     },
     {
       icon: '📊',
       title: 'Progress tracking',
       desc: 'Track your progress while studying.'
     },
     {
       icon: '🥇',
       title: 'Rewards',
       desc: 'Get rewards for correctly answered questions.'
     },
  {
    icon: '🎴',
    title: 'Flashcards',
    desc: 'Turn your notes or PDFs into instant flashcards with AI-powered question creation.'
  },
  {
    icon: '📖',
    title: 'Improve your vocabulary',
    desc: 'Get important words from your content and improve your vocabulary.'
  },
  {
    icon: '🙎‍♂️',
    title: 'Humanized Text',
    desc: 'Get humanized text from your content and make AI generated content more human.'
  },
  {
    icon: '🌎',
    title: 'Summaries',
    desc: 'Get summaries from your content and get concepts crystal clear.'
  },
  { 
      icon: '✅',
      title: 'Correct your grammar',
      desc: 'Get Grammar corrections of your content!'
    },
   { 
    icon: '🥇',
    title: 'Get answers to your questions',
    desc: 'Get answers to your questions from your content with explanations.'
    },
];

const userAvatars = [
  'https://i.pravatar.cc/150?img=1',
  'https://i.pravatar.cc/150?img=2',
  'https://i.pravatar.cc/150?img=3',
  'https://i.pravatar.cc/150?img=4',
  'https://i.pravatar.cc/150?img=5'
];
const diff = [
  { 
    icon: '🤔',
    title: 'What are we?',
    desc: 'We are not another AI study tool, we aim to create a personalised study assistant / study buddy.'
   },
   {
     icon: '📖',
     title: 'We understand the pain',
     desc: 'It is difficult, time consuming and less productive doing repetitive tasks again and again. Here, you wont face the problem.'
   },
   { 
     icon: '🤩',
     title: 'It is free ',
     desc: 'My aim is to keep this tool free or at least affordable for students. '
     },
     {
       icon: '📌',
       title: 'Differentiation',
       desc: 'there are very less or no AI tools that offer these much features, they are unique and our platform is faster than most AI tools.'
     },
];

const benefs = [
  {
    icon: '📌',
    title: 'One tool for all learning styles and every feature',
    desc: 'A single AI tool has it all- from diagrams, mindmaps, to converting text into handwriting. Everything is here.'
  },
  { 
    icon: '⌚',
    title: 'Time is currency. We help you save it',
    desc: 'Save 5+ hours of study per week. No need of manual and time-consuming work.'
   },
   {
     icon: '⚡',
     title: 'Gain 2x more knowledge in same amount of time!',
     desc: 'hmm.. sounds interesting. Give it a try! AI is your study buddy now!'
   },
   {
     icon: '⚡',
     title: 'Not only students, Teachers are also a part of us!',
     desc: 'We recently introduced a feature of question paper generation! No need of manual question paper generation!'
   },
   { 
     icon: '🤩',
     title: 'Prepare exams with instant quizzes!',
     desc: 'Whether you are a JEE/NEET aspirant, or just want to gain some knowledge, testing is the key! '
     },
];

const faqs = [
  {
    q: 'Is NexNotes AI free to use?',
    a: 'Yes!'
  },
  {
    q: 'Who built NexNotes AI and how can i reach out support?',
    a: 'The founder of NexNotes AI is Arush Sharma. I am the founder, developer, marketer, and everything else of NexNotes AI. My e-mail id : arush2022pro@gmail.com'
  },
  {
    q: 'Why not use ChatGPT?',
    a: 'ChatGPT is good for day-to-day queries and generic questions, but it does not offer unique features and personalised tracking, rewarding, learning, improvement tips and is NOT optimised for studying purpose. ChatGPT is a bot, NexNotes AI is your personalised teacher with wide range of features.'
  },
  {
    q: 'Will I get rewards for my answers?',
    a: 'Absolutely! You will get bronze, silver and gold medals for answering questions!.'
  },
  {
    q: 'Can teachers generate question papers?',
    a: 'Yes, teachers can generate question papers and customize question difficulty.'
  },
  {
    q: 'Is my data secure?',
    a: 'Absolutely. we DO NOT STORE YOUR DATA ANYWHERE, visit privacy policy tab for more info.'
  },
];

const LandingPage = () => {
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const texts = ['memory ', 'QPs', 'mindmap', 'flashcards', 'summary', 'Diagrams', 'Doubts', 'PPT', 'Vocab'];
  const [openFaq, setOpenFaq] = useState(null);
  
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
    }, 2000);
    
    return () => clearInterval(interval);
  }, [texts.length]);

  // Intersection Observer for scroll animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    const elements = document.querySelectorAll('.scroll-animate');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const textGradient = 'text-gradient';
  const buttonGradient = 'button-gradient';
  const glassEffectPrimary = 'glass-effect';

  return (
    <div className="flex flex-col items-center justify-between min-h-[calc(100vh-14rem)] text-white relative z-10 px-4 sm:px-6 py-8">
      <div 
        className="lumin-landing-bg" 
        style={{
          backgroundImage: `url(${bg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>
            <div className="relative z-10 px-4 sm:px-6 py-8 max-w-7xl mx-auto">
        {/* User Testimonial Section - Exactly like screenshot */}
        <div className="flex flex-col items-center mb-12 animate-fade-in">
          {/* User Avatars */}
          <div className="flex items-center -space-x-3 mb-3">
            {userAvatars.map((avatar, i) => (
              <div key={i} className="relative">
                <img 
                  src={avatar} 
                  alt={`User ${i + 1}`}
                  className="w-12 h-12 rounded-full border-2 border-slate-900 object-cover hover:scale-110 transition-transform duration-300"
                />
              </div>
            ))}
          </div>
          {/* User Count Text */}
          <p className="text-slate-300 text-sm font-medium tracking-wide">
            Witness with <span className="font-bold text-white">10K+</span> users worldwide!
          </p>
          
          {/* Version Badge */}
          <div className="mt-4 flex items-center gap-2 bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 rounded-full px-4 py-2">
            <span className="bg-gradient-to-r from-purple-500 to-pink-500 text-white text-xs font-bold px-2 py-0.5 rounded-full">
              New
            </span>
            <span className="text-slate-200 text-sm">A big update is loading! Stay tuned!</span>
          </div>
        </div>
      
      <div className="flex flex-col items-center justify-center flex-grow text-center max-w-4xl mx-auto relative z-20 fade-in-up">
       

        <h2 className="text-4xl sm:text-6xl font-medium mb-5 leading-snug">
          <span className="text-white">From notes to </span>
          <span className="inline-block h-[70px] overflow-hidden align-middle text-gradient">
            <span key={texts[currentTextIndex]} className="text-gradient block text-rotating">
              {texts[currentTextIndex]}
            </span>
          </span>
        </h2>

        <p className="text-xl font-medium sm:text-xl text-gray-300 mb-10 max-w-3xl mx-auto opacity-90 fade-in-up-delay-2">
          Turn notes into Question papers, mind maps, diagrams, handwritten notes, summaries, quizzes and much more - in seconds for free.
        </p>

        <div className="flex flex-wrap justify-center gap-4 sm:gap-6 fade-in-up-delay-3">
          <Link
            to='/app'
            className={`inline-block px-8 py-3 rounded-full text-lg font-regular text-white shadow-lg transition-all duration-300 ${buttonGradient}`}
          >
            🔓Try it out!
          </Link>

          {/* <Link
            to="/app"
            className={`inline-block px-8 py-3 rounded-full text-lg font-regular text-white shadow-lg transition-all duration-300 ${glassEffectPrimary}`}
          >
            ▶️Try it out →
          </Link> */}
        </div>

        <section className="w-full max-w-4xl mx-auto mt-10 mb-4">
          <h3 className="text-3xl font-semibold text-center text-gradient">"Ranked #2 in top Research startups in the world by F6S!"</h3>
        </section>



 {/* Demo Video Section */}
 <div className="mt-2 sm:mt-2 max-w-9xl w-full"> <div className="relative rounded-3xl overflow-hidden glass-effect p-4 sm:p-2"> <div className="absolute inset-0 z-0 bg-gradient-to-r from-grey-200/30 to-black animate-pulse blur-lg"></div> <video className="relative z-20 w-full h-auto rounded-2xl" controls src="/PROMOVID.mp4" > Your browser does not support the video tag. </video> </div> </div> </div>

 <div className="mt-4 flex items-center gap-2 bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 rounded-full px-4 py-2">
            <span className="bg-gradient-to-r from-purple-500 to-pink-500 text-white text-xs font-bold px-2 py-0.5 rounded-full">
              New
            </span>
            <span className="text-slate-200 text-sm">White Label Option now available! Contact us for white labeling under your brand!</span>
          </div>
        </div>
      <div className="flex flex-col items-center justify-center flex-grow text-center max-w-4xl mx-auto relative z-20 mt-10">
        <h3 className="text-3xl font-bold text-center mb-2 text-gradient scroll-animate">"Used in over 100 countries by over 10k students!"</h3>
      </div> 

      <div className="flex flex-col items-center justify-center flex-grow text-center max-w-4xl mx-auto relative z-20 mt-5 mb-100 scroll-animate">
        <div className="flex flex-col md:flex-row justify-center space-y-4 md:space-x-4 space-x-0 items-center">
        
   
          <a href="https://twelve.tools" target="_blank" rel="noopener noreferrer">
            <img src="https://twelve.tools/badge2-dark.svg" alt="Featured on Twelve Tools" width="200" height="54" />
          </a>

        

          <a href="https://startupslab.site" target="_blank" rel="noopener noreferrer">
            <img src="https://cdn.startupslab.site/site-images/badge-dark.png" alt="Featured on Startups Lab" width="200" height="54" />
          </a>

          <a href="https://dang.ai/" target="_blank" rel="noopener noreferrer">
            <img src="https://cdn.prod.website-files.com/63d8afd87da01fb58ea3fbcb/6487e2868c6c8f93b4828827_dang-badge.png" alt="Dang.ai" width="150" height="54"/>
          </a>
        </div>
      </div>

      <div className="flex flex-col items-center justify-center flex-grow text-center max-w-4xl mx-auto relative z-20 mt-10">
        <h3 className="text-3xl font-bold text-center mb-2 text-gradient scroll-animate">"What do we provide?"</h3>
      </div> 

      <section className="w-full max-w-6xl mx-auto mt-5 mb-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-8">
          {functionalities.map((f, index) => (
            <div 
              key={f.title} 
              className="glass-effect rounded-3xl p-6 flex flex-col items-center text-center scroll-animate"
              style={{animationDelay: `${index * 0.1}s`}}
            >
              <div className="text-4xl mb-3">{f.icon}</div>
              <h4 className="text-xl font-semibold mb-2">{f.title}</h4>
              <p className="text-gray-300 text-sm">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <div className="flex flex-col items-center justify-center flex-grow text-center max-w-4xl mx-auto relative z-20 mt-10">
        <h3 className="text-3xl font-bold text-center mb-2 text-gradient scroll-animate">What makes us different ?</h3>
      </div> 

      <section className="w-full max-w-6xl mx-auto mt-5 mb-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-8">
          {diff.map((f, index) => (
            <div 
              key={f.title} 
              className="glass-effect rounded-3xl p-6 flex flex-col items-center text-center scroll-animate"
              style={{animationDelay: `${index * 0.1}s`}}
            >
              <div className="text-4xl mb-3">{f.icon}</div>
              <h4 className="text-xl font-semibold mb-2">{f.title}</h4>
              <p className="text-gray-300 text-sm">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <div className="flex flex-col items-center justify-center flex-grow text-center max-w-4xl mx-auto relative z-20 mt-10">
        <h3 className="text-3xl font-bold text-center mb-2 text-gradient scroll-animate">"Benefits of using our platform"</h3>
      </div> 

      <section className="w-full max-w-6xl mx-auto mt-5 mb-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-8">
          {benefs.map((f, index) => (
            <div 
              key={f.title} 
              className="glass-effect rounded-3xl p-6 flex flex-col items-center text-center scroll-animate"
              style={{animationDelay: `${index * 0.1}s`}}
            >
              <div className="text-4xl mb-3">{f.icon}</div>
              <h4 className="text-xl font-semibold mb-2">{f.title}</h4>
              <p className="text-gray-300 text-sm">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="w-full max-w-3xl mx-auto mb-16">
        <div className="flex flex-col items-center justify-center flex-grow text-center max-w-4xl mx-auto relative z-20 mt-10">
          <h3 className="text-3xl font-bold text-center mb-2 text-gradient scroll-animate">Very frequently asked questions</h3>
        </div> 

        <div className="space-y-4 mt-8">
          {faqs.map((faq, idx) => (
            <div 
              key={faq.q} 
              className="glass-effect rounded-xl p-4 scroll-animate"
              style={{animationDelay: `${idx * 0.1}s`}}
            >
              <button
                className="w-full text-left flex justify-between items-center text-lg font-semibold focus:outline-none"
                onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
              >
                <span>{faq.q}</span>
                <span className="ml-2">{openFaq === idx ? '−' : '+'}</span>
              </button>
              {openFaq === idx && (
                <div className="mt-2 text-gray-300 text-base animate-fade-in">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
          
        
        <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
          {/* <h3 className="text-3xl font-bold text-center text-gradient">Study smarter, Not harder.</h3> */}
            <Link
              to="/app"
              className={`inline-block px-8 py-3 rounded-full text-lg font-bold text-white shadow-lg transition-all duration-300 ${buttonGradient}`}
            >
              Start Now! →
            </Link>
          </div>
        

          <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
            <Link
              to="/blog"
              className={`inline-block px-8 py-3 rounded-full text-lg font-bold text-white shadow-lg transition-all duration-300 ${buttonGradient}`}
            >
              Blogs →
            </Link>
          </div>
        
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
            <div className="flex flex-col items-center justify-center flex-grow text-center max-w-4xl mx-auto relative z-20 fade-in-up">
              <a href="https://startupfa.me/s/nexnotes-ai?utm_source=nexnotes-ai.pages.dev" target="_blank" rel="noopener noreferrer">
                <img src="https://startupfa.me/badges/featured/dark-small-rounded.webp" alt="Featured on Startup Fame" width="300" height="10" />
              </a>

              <footer className="w-full py-6 mt-10 border-t border-gray-700 flex flex-col items-center space-y-4">
                <p className="text-gray-400 text-sm">© 2025 NexNotes AI. All rights reserved.</p>
                <p className="text-gray-400 text-sm">Founder's contact for white label opportunities or support- arush2022pro@gmail.com.</p>
                <div className="flex space-x-6 text-2xl">
                  <a href="https://x.com/@arush_shar17296" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400">
                    <FaXTwitter />
                  </a>
                  <a href="https://www.youtube.com/@NexNotesAIStudyHelp" target="_blank" rel="noopener noreferrer" className="hover:text-red-500">
                    <FaYoutube />
                  </a>
                  <a href="https://linkedin.com/in/arush-sharma-dev" target="_blank" rel="noopener noreferrer" className="hover:text-pink-500">
                    <FaLinkedin />
                  </a>
                </div>
              </footer>
            </div>
          </div>
        </div>
      </section>
    </div>
  
 
  );
};

export default LandingPage;